import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionQaInspectionsService } from '../services/constructionQaInspections.service';
import type { ConstructionQaInspection } from '../types/construction-qa.types';
import { toast } from 'sonner';

export function useConstructionQaDetail(id?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-qa-inspections', 'detail', id],
    queryFn: () => ConstructionQaInspectionsService.getInspectionDetail(id!),
    enabled: !!id,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<ConstructionQaInspection>) => ConstructionQaInspectionsService.updateInspection(id!, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-qa-inspections'] });
      queryClient.invalidateQueries({ queryKey: ['construction-qa-inspections', 'detail', id] });
      toast.success('Cập nhật phiếu kiểm tra QA thành công');
    },
  });

  return {
    inspection: query.data,
    isLoading: query.isLoading,
    updateInspection: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
